import { routes } from "src/shared/routes";
import {
  FAQS,
  FooterLinks,
  NavSubmenuLinks,
  AnalyticsHeader,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
  HomePageZeroStateDesc,
} from "./helper";
import orderSummeryBg from "public/images/azdbacks/arizona-diamondbacks-baseball-field.jpg";
import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const tm_sandbox_pass: TTeamConfig = {
  TEAM_SCHEMA: "tm_sandbox_pass",
  TEAM_FULL_NAME: "Arizona Diamondbacks",
  BROWSER_TITLE: "Ballpark Pass",
  CLIENT_ID: "9905940d1e7e.seasonshare.integ3-sandbox.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#A71930",
    COLORS_SECONDARY: "#E3D4AD",
    IS_INTERCOM_ENABLED: true,
    IS_BALLPARK_APP: true,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
      ADDITIONAL_SUB_MENU_ITEMS: NavSubmenuLinks,
    },
    DEFAULT_APP_ROUTE: routes.landing,
    FOOTER: {
      BACKGROUND_COLOR: "#A71930",
      LINKS: FooterLinks,
      COPYRIGHT_TEXT: `© ${new Date().getFullYear()}`,
    },
    ANALYTICS_HEADER: AnalyticsHeader,
    IS_CROWD_HANDLER_ENABLED: true,
  },

  LANDING_PAGE_SETTINGS: {
    SHOW_ALL_PASSES_UNDER_BANNER: true,
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    PASS: {
      SUBSCRIBE_BUTTON_TEXT: "Buy Now!",
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    EVENT_CARD: {
      ADD_ON_DISPLAY_MODE: "list",
    },

    ZERO_STATE: {
      TITLE: "You don’t currently have a pass on your account.",
      DESCRIPTION: <HomePageZeroStateDesc />,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
    },
    SEND_GIFT_SUCCESS_MODAL: {
      SEND_NOW_TITLE: "Your gift is on its way!",
      SEND_NOW_DESCRIPTION:
        "Your purchase was successful. The recipient will receive an email shortly with your message and instructions for redeeming their pass.",

      SEND_LATER_TITLE: "Your gift has been scheduled! ",
      SEND_LATER_DESCRIPTION:
        "Your purchase was a success. The recipient will receive their gift email on the scheduled date, complete with your message and simple steps to redeem.",
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL: "https://ss-leagues.s3.amazonaws.com/MLB-3/AZD-UPDATED.png",
    ORDER_SUMMERY_BACKGROUND_URL: orderSummeryBg.src,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PASS_PURCHASE_SUCCESS_MESSAGE,
  },
};
